export const appBroadcast = new BroadcastChannel('bm-admin');